<div class="form-field">
  @if (label) {
  <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
  <label class="form-label">{{ label }}</label>
  }
  <div class="form-control">
    <ng-content></ng-content>
  </div>
  @if (error) {
  <span class="form-error">{{ error }}</span>
  }
</div>